var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.31694 4.19194C7.43415 4.07473 7.5 3.91576 7.5 3.75C7.5 3.58424 7.43415 3.42527 7.31694 3.30806C7.19973 3.19085 7.04076 3.125 6.875 3.125H4.375V0.625C4.375 0.45924 4.30915 0.300269 4.19194 0.183058C4.07473 0.0658482 3.91576 0 3.75 0C3.58424 0 3.42527 0.0658482 3.30806 0.183058C3.19085 0.300269 3.125 0.45924 3.125 0.625V3.125H0.625C0.45924 3.125 0.300268 3.19085 0.183058 3.30806C0.0658479 3.42527 0 3.58424 0 3.75C0 3.91576 0.0658479 4.07473 0.183058 4.19194C0.300268 4.30915 0.45924 4.375 0.625 4.375H3.125V6.875C3.125 7.04076 3.19085 7.19973 3.30806 7.31694C3.42527 7.43415 3.58424 7.5 3.75 7.5C3.91576 7.5 4.07473 7.43415 4.19194 7.31694C4.30915 7.19973 4.375 7.04076 4.375 6.875V4.375H6.875C7.04076 4.375 7.19973 4.30915 7.31694 4.19194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.1a8c6c7f891444ea8ed024dba76cc1c3.svg";
export { ForwardRef as ReactComponent };